
eval("define(\'text!QuickViewTemplate.html\',[],function () { return \'<div id=\"quick-view-container\">\\n    <div class=\"preview-content\">\\n    </div>\\n</div>\';});\n\n//# sourceURL=/text!QuickViewTemplate.html");

